module.exports = "/_next/static/images/denver-co-f3ccc6bbcf485a50ba304cd8c3e91239.jpg";